import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined,LoadingOutlined } from '@ant-design/icons';
import Modal from 'antd/lib/modal/Modal';
import { Form, Button, Input, Skeleton, Space, message } from 'antd';
import { transformPro } from '../../shared/hooks/transfromApiData';
import { useQueryHook } from '../../shared/hooks/useQueryHook';
import { useMutationHook } from '../../shared/hooks/useMutationHook';
import { companyData } from '../../core/auth';
import { AddProductName, GetAllProductNames, DeleteProductName, UpdateProductName } from '../../shared/common/graphqlQuery';
import CommonEditableTable from '../../shared/components/commonEditableTable/commonEditableTable';
const onError = (error: any, result: any) => {
    console.log(error, result);
}
let deleteId;

const columns = [
    {
        title: 'Product Name',
        dataIndex: 'productName',
        key: 'productName',
        width: '15%',
        editable: true,
        sorter: true,
    },
    {
        title: 'HS Code',
        dataIndex: 'hsCode',
        key: 'hsCode',
        width: '15%',
        editable: true,
        sorter: true,
    },
    {
        title: 'Product Type',
        dataIndex: 'productType',
        key: 'productType',
        width: '15%',
        editable: true,
        sorter: true,
    }, 
    {
        title: 'Unit Type',
        dataIndex: 'unitType',
        key: 'unitType',
        width: '15%',
        editable: true,
        sorter: true
    }
];
const ProductList = () => {
    const companyId = companyData().getCompanyData();
    const [ProductNamesform] = Form.useForm();
    const ProductNamesQuery = useQueryHook(GetAllProductNames, { companyId: companyId });
    const [ProductListData, setProductListData] = useState([]);

    useEffect(() => {
        setProductListData(transformPro(ProductNamesQuery.data?.getAllProductNames))
    }, [ProductNamesQuery.data?.getAllProductNames]);

    const onSubmittedProductName = (result: any) => {
        const newAddedData = transformPro(result.addProductName);
        const tableData = [...ProductListData];
        tableData.push(...newAddedData);
        setProductListData([...tableData]);
        handleCancelProducts();
    }

    const onDeleteProductName = (result: any) => {
        const constData = [...ProductListData];
        const deletedIndex = constData.findIndex(eachData => eachData.key === deleteId);
        constData.splice(deletedIndex, 1);
        setProductListData([...constData]);
        message.success(result.deleteProductName.message);
    }

    const onUpdatedProductName = (result: any) => {
        const newData = [...ProductListData];
        const index = newData.findIndex(item => result.updateProductName['_id'] === item.key);
        if (index > -1) {
            result.updateProductName.key = result.updateProductName['_id'];
            newData[index] = result.updateProductName;
            setProductListData([...newData])
        }
    }

    const ProductNameMutation = useMutationHook(AddProductName, onSubmittedProductName, onError);
    const DeleteProductNameMutation = useMutationHook(DeleteProductName, onDeleteProductName, onError);
    const UpdateProductNameMutation = useMutationHook(UpdateProductName, onUpdatedProductName, onError);

    const [visibleProducts, setVisibleProducts] = useState(false);
    const [confirmLoadingProducts, setConfirmLoadingProducts] = useState(false);

    const showModalProducts = () => {
        setVisibleProducts(true);
    };
    const handleCancelProducts = () => {
        setVisibleProducts(false);
        ProductNamesform.resetFields();
    };
    const onFinishProducts = (values: any) => {
        if(!ProductNameMutation.loading) {
            ProductNameMutation.callMutation({ variables: { productNameInput: { ...values, companyId } } })
        }
    };

    const onSave = (value) => {
        console.log(value, 'value');
        
        if(!UpdateProductNameMutation.loading) {
            UpdateProductNameMutation.callMutation({ variables: { updateProductNameInput: { companyId, productNameId: value.key, productName: value.productName, productType: value.productType, hsCode: value.hsCode, unitType: value.unitType} } })
        }
    }
    const onDelete = (value) => {
        if(!DeleteProductNameMutation.loading) {
            deleteId = value.key;
            DeleteProductNameMutation.callMutation({ variables: { deleteProductNameInput: { companyId, productNameId: value.key } } })
        }
    }
    return (

        <>
            <Button type="primary" onClick={showModalProducts} style={{ marginBottom: 10, marginTop: 10 }}>
                Add Products
            </Button>
            <Modal
                title="Add Products"
                style={{ top: 20 }}
                visible={visibleProducts}
                onCancel={handleCancelProducts}
                footer={[
                    <Button key="back" style={{ width: 75 }} onClick={handleCancelProducts}>
                        Cancel
                    </Button>,
                    <Button key="submit" type="primary" ghost style={{ width: 75 }} loading={confirmLoadingProducts} onClick={() => {
                        ProductNamesform
                            .validateFields()
                            .then(values => {
                                onFinishProducts(values);
                            })
                            .catch(info => {
                                console.log('Validate Failed:', info);
                            });
                    }}>
                        {ProductNameMutation.loading ? <LoadingOutlined style={{ fontSize: '20px' }} /> : 'Submit'}
                    </Button>,
                ]}>
                <Form
                    form={ProductNamesform}
                    name="dynamic_form_nest_item" initialValues={[]}>
                    <Form.List name="products">
                        {(fields, { add, remove }) => {
                            return (
                                <div>
                                    {fields.map(field => (
                                        <Space key={field.key} style={{ display: 'flex', marginBottom: 8 }} align="start">
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'productName']}
                                                fieldKey={[field.fieldKey, 'productName']}
                                                rules={[{ required: true, whitespace: true, message: 'Missing Product name' }]}
                                            >
                                                <Input autoComplete="off" placeholder="Product name" />
                                            </Form.Item>
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'hsCode']}
                                                fieldKey={[field.fieldKey, 'hsCode']}
                                                rules={[{ required: true, whitespace: true, message: 'Missing HS Code' }]}
                                            >
                                                <Input autoComplete="off" placeholder="HS Code" />
                                            </Form.Item>
                                            
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'productType']}
                                                fieldKey={[field.fieldKey, 'productType']}
                                                rules={[{ required: true, whitespace: true, message: 'Missing Product Type' }]}
                                            >
                                                <Input autoComplete="off" placeholder="Product Type" />
                                            </Form.Item>
                                            <Form.Item
                                                {...field}
                                                name={[field.name, 'unitType']}
                                                fieldKey={[field.fieldKey, 'unitType']}
                                                rules={[{ required: true, whitespace: true, message: 'Missing Unit Type' }]}
                                            >
                                                <Input autoComplete="off" placeholder="Unit Type" />
                                            </Form.Item>
                                            <MinusCircleOutlined
                                                onClick={() => {
                                                    remove(field.name);
                                                }}
                                            />
                                        </Space>
                                    ))}
                                    <Form.Item>
                                        <Button
                                            type="dashed"
                                            onClick={() => {
                                                add();
                                            }}
                                            style={{ width: '60%' }}
                                        >
                                            <PlusOutlined /> Add field
                                        </Button>
                                    </Form.Item>
                                </div>
                            );
                        }}
                    </Form.List>
                </Form>
            </Modal>

            {ProductNamesQuery.loading ? <Skeleton active /> :
                <CommonEditableTable
                    columns={columns}
                    tableRowdata={ProductListData}
                    onDelete={onDelete}
                    onSave={onSave}
                    customFormData={{ productName: '', hsCode: '', productType: '',unitType: '' }} />
            }
        </>

    );
}
export default ProductList

// tfsqzmodbobugkmlzp@miucce.com